import React, { type FunctionComponent } from 'react'
import { DashButton } from 'legacy/dash-blocks/dash-button/DashButton'
import { useGoToPath } from 'utils/routing/navigation.hooks'
import { useDashIntl } from 'intl/intl.hooks'
import { type DashMessages } from 'intl/intl.types'

interface Props {
  labelId: DashMessages
}

export const GeneratedReportsListRouteToNew: FunctionComponent<Props> = ({ labelId }) => {
  const intl = useDashIntl()
  const goToAddNewReport = useGoToPath('generated-reports-add')

  return <DashButton onClick={goToAddNewReport}>{intl.formatMessage({ id: labelId })}</DashButton>
}
